module.exports = __webpack_public_path__ + "static/img/LOGO.336952af.png";